import { SharedBusinessEntity } from "../shared/_config/api/shared-business-entity";
import { AddTarResponseI, ExtAddTarQueryI, MapAddTar } from "../store/add-tar";
import { ApiSharedMethod } from "./api-methods.shared";

export class ApiTarMethod<T1, T2>  extends ApiSharedMethod<T1, T2> {
    // Add Tar
    static readonly addTar = new ApiSharedMethod<AddTarResponseI, ExtAddTarQueryI>(
        1,
        SharedBusinessEntity.vbsBooking,
        `addLocalTar`,
        MapAddTar.mapResult,
        MapAddTar.mapQuery,
    );
}